function parseRouteQuery(routeQuery) {
  const filters = {};
  const sort = {};

  for (const [key, value] of Object.entries(routeQuery)) {
    if (key.startsWith("filters[")) {
      const filterKey = key.slice(8, -1); // Extract key between 'filters[' and ']'
      filters[filterKey] = value;
    } else if (key.startsWith("sort[")) {
      const sortKey = key.slice(5, -1); // Extract key between 'sort[' and ']'
      sort[sortKey] = value;
    }
  }

  return { filters, sort };
}

export default parseRouteQuery;
